
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.no-data {
    background-color: var(--gray-professional-lighten-2);
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 4rem;
    padding-bottom: 4rem;
    text-align: center;
    font-size: var(--fs-lg);
    line-height: var(--lh-lg);
    font-weight: var(--fw-semibold);
    color: var(--outline-white)
}
@media (min-width: 1024px) {
    .no-data {
        padding-top: 6rem;
        padding-bottom: 6rem
    }
    .no-data {
        font-size: var(--fs-xl);
        line-height: var(--lh-xl)
    }
}
`;